// https://github.com/FortAwesome/vue-fontawesome#integrating-with-other-tools-and-frameworks
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown,
  faQuestionCircle,
  faSquare,
  faLongArrowAltRight,
  faInfo,
} from "@fortawesome/free-solid-svg-icons";
// import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faChevronDown,
  faQuestionCircle,
  faSquare,
  faLongArrowAltRight,
  faInfo
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
